import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import { styled } from "@mui/system";
import * as React from "react";
import { useDispatch } from "react-redux";
import { ideaAccessAllDataRequest } from "redux/features/access-request/accessRequestAllSlice";
import AccessRequestTable from "./AccessRequestTable";
import { getAllAccessRequests } from "services/accessRequestService";
import { toast } from "react-toastify";
import { IDataType } from "redux/features/connect/connectAllSlice";
import IdeaSaleFilter from "components/IdeaSaleFilter";

const TabCover = styled("div")({
  height: "100%",
  width: "100%",
});

export type IAccessRequestStatusType =
  | "pending"
  | "accepted"
  | "rejected"
  | "all";

export default function AccessRequestTabs() {
  const [value, setValue] = React.useState<IAccessRequestStatusType>("all");
  const [isFetched, setIsFetched] = React.useState(false);

  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(
      ideaAccessAllDataRequest({
        status: value === "all" ? null : value,
      })
    );
  }, [dispatch, isFetched, value]);

  const handleChange = (
    event: React.SyntheticEvent,
    newValue: IAccessRequestStatusType
  ) => {
    setIsFetched(false);
    setValue(newValue);
  };

  const [allData, setAllData] = React.useState([]);

  const getAllData = async () => {
    const res = await getAllAccessRequests(null)
    if (res?.status === 200 || res.status === 201) {
      setAllData(res?.data);
    } else {
      toast("Something went wrong");
    }
  }

  React.useEffect(() => {
    getAllData();
  }, [value]);

  const acceptedCount = allData.filter((data: IDataType) => data.status === "Accepted").length
  const rejectedCount = allData.filter((data: IDataType) => data.status === "Rejected").length
  const pendingCount = allData.filter((data: IDataType) => data.status === "Pending").length

  return (
    <Box
      sx={{ width: "100%", typography: "body1" }}
      className="content-center"
      id="center-content"
    >
      <TabCover className="idea-form">
        <span className="tab-title">Access Requests</span>
        <TabContext value={value}>
          <Box display='flex' justifyContent='space-between'>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <TabList onChange={handleChange} aria-label="lab API tabs example">
                <Tab
                  sx={{ textTransform: "capitalize" }}
                  label={"All" + ` (${allData.length})`}
                  value="all"
                />
                <Tab
                  sx={{ textTransform: "capitalize" }}
                  label={"Pending" + ` (${pendingCount})`}
                  value="pending"
                />
                <Tab
                  sx={{ textTransform: "capitalize" }}
                  label={"Accepted" + ` (${acceptedCount})`}
                  value="accepted"
                />
                <Tab
                  sx={{ textTransform: "capitalize" }}
                  label={"Rejected" + ` (${rejectedCount})`}
                  value="rejected"
                />
              </TabList>
            </Box>
            <Box mt="30px">
              <IdeaSaleFilter />
            </Box>
          </Box>

          <Box mt="-16px">
            <TabPanel value="all">
              <AccessRequestTable />
            </TabPanel>
            <TabPanel value="pending">
              <AccessRequestTable />
            </TabPanel>
            <TabPanel value="accepted">
              <AccessRequestTable />
            </TabPanel>
            <TabPanel value="rejected">
              <AccessRequestTable />
            </TabPanel>
          </Box>
        </TabContext>
      </TabCover>
    </Box>
  );
}
